import React, { useCallback, useEffect, useState } from "react";
import SubNav from "../../../Shared/SubNav";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import socket from "../../../context/socket";
import axios from "axios";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { fetchAdvisorData } from "../../../redux/advisor/advisorSlice";
import { fetchClientData } from "../../../redux/client/clientSlice";
import api from "../../../utils/api";

const MarketTiming = () => {
  const [selectedCards, setSelectedCards] = useState([]);
  const navigate = useNavigate();
  const roomId = new URLSearchParams(useLocation().search).get("clientId");
  const [marketTimingData, setMarketTimingData] = useState();
  const [isError, SetError] = useState("");
  const { clientData } = useSelector((state) => state.client);
  const dispatch = useDispatch();
  const [currentIP, setCurrentIP] = useState("");


  console.log("selectedCards", selectedCards);

  // For getting Card Data
  useEffect(() => {
    api
      .get(`advisor/get_inbelief_section/third`)
      .then((response) => {
        const data = response.data;
        console.log("Message Received:", data);
        dispatch(fetchClientData(roomId));

        setMarketTimingData(data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
      getIP()
  }, [roomId]);

  // Fetch previously selected cards
  useEffect(() => {

    if (clientData?.contribution_to_investing) {
      setSelectedCards(clientData.contribution_to_investing);
    }
  }, [clientData]);

  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);

  // Debounced function to emit messages
  const debouncedEmitMessage = useCallback(
    _.debounce(() => {
      socket.emit("message", { room: roomId, data: { selectedCards } });
    }, 300),
    [selectedCards]
  );

  useEffect(() => {
    debouncedEmitMessage();
  }, [selectedCards, debouncedEmitMessage]);

  const handleNext = () => {
    const roomId = new URLSearchParams(window.location.search).get("clientId");
    const nextUrl = "/get-on-same-page?clientId=" + roomId;
    const nextUrl2 = "/get-on-same-page";

    const allSectionIds = marketTimingData && marketTimingData.section.map(
      (section) => section._id
    );
    const selectedCardIds = selectedCards.map((card) => card._id);
    const allSelected = allSectionIds.every((id) =>
      selectedCardIds.includes(id)
    );
    // if (!allSelected) {
    //   SetError("* Please Prioritize all Beliefs!");
    //   return;
    // }
    if (!allSelected) {
      Swal.fire({
        icon: 'warning',
        title: 'Warning',
        text: 'Please Prioritize all Beliefs!',
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'swal-confirm-btn  ',
        },
      });
      return;
    }


     // Deep compare priorities and order
     const original = clientData?.contribution_to_investing || [];
     const updated = selectedCards;
   
     const isSame = original.length === updated.length &&
       original.every((item, index) =>
         item._id === updated[index]._id && item.priority === updated[index].priority
       );
    const allData = {
      _id: roomId,
      contributionToInvesting: selectedCards,
    };
    api
      .post(
       "advisor/contributionToInvesting",
        allData
      )
      .then((response) => {
        if (!isSame) {
          console.log('yes');
          
          sendAggredStatus(); // Only call if changed
        }

        // Emit the navigation event after saving the message
        dispatch(fetchClientData(roomId))

        socket.emit("navigate", { room: roomId, url: nextUrl2 });
        navigate(nextUrl); // Navigate to the next page in the advisor app
      })
      .catch((error) => {
        console.error("Error saving message:", error);
      });

    socket.emit("navigate", { room: roomId, url: nextUrl2 });
    navigate(nextUrl);
    dispatch(fetchClientData(roomId));
  };

  const getIP = async () => {
    // const ipResponse = await axios.get("https://api64.ipify.org?format=json");
    // console.log("My IP:", ipResponse.data.ip);

    // const currentIP = ipResponse.data.ip;
    
    // const currentIP ='111.111.1.11';


    setCurrentIP(currentIP);
  }

  const sendAggredStatus = async () => {
    try {
      // Get current date and time
      const currentDateTime = new Date().toISOString();
  
      const res = await fetch("https://www.finedge.in/home/getRemoteHeaders");
      const data = await res.json()
      console.log('response',data?.ip); 
  
      // Send data to backend
      const response = await api.post("advisor/set_inbelief_agreed",
        {
          _id: roomId,
          inv_belief_agreed:'no',
          inv_belief_agreed_date:currentDateTime,
          inv_belief_agreed_IP:data?.ip,
        }
      );
  
      // dispatch(fetchClientData(roomId));
      console.log("yes", response);
    } catch (error) {
      console.log("Some Errors", error);
    }
  };

  const handleBack = () => {
    const roomId = new URLSearchParams(window.location.search).get("clientId");
    const prevUrl = "/risk-reward?clientId=" + roomId;
    const prevUrl2 = "/risk-reward" ;

    socket.emit("navigate", { room: roomId, url: prevUrl2 });
    navigate(prevUrl);
  };

  const handleCardClick = (_id) => {
    setSelectedCards((prevSelectedCards) => {
      const isSelected = prevSelectedCards.some((card) => card._id === _id);

      if (isSelected) {
        return prevSelectedCards
          .filter((card) => card._id !== _id)
          .map((card, index) => ({ ...card, priority: index + 1 }));
      } else {
        return [
          ...prevSelectedCards,
          { _id, priority: prevSelectedCards.length + 1 },
        ];
      }
    });
  };

  const getCardStyle = (_id) => ({
    backgroundColor: selectedCards.some((card) => card._id === _id)
      ? " #23674B"
      : "white",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    minHeight: "242px",
  });
  const getCardTextStyle = (cardId) => ({
    color: selectedCards.some((card) => card._id === cardId) ? "#fff" : "#000",
  });

  const getCardNumber = (_id) => {
    const card = selectedCards.find((card) => card._id === _id);
    return card ? card.priority : "";
  };

  const cardData = [
    {
      _id: 1,
      imgSrc: "assets/images/Robot-delivering.svg",
      text: "Market Timing",
    },
    {
      _id: 2,
      imgSrc: "assets/images/lowest-cost.svg",
      text: "The “lowest cost” investment - irrespective of fitment",
    },
    {
      _id: 3,
      imgSrc: "assets/images/documents.svg",
      text: "Selection of Top Performing Funds",
    },
    {
      _id: 4,
      imgSrc: "assets/images/compounding.svg",
      text: "Discipline, Goal Focus & Power of Compounding",
    },
  ];

  const containerStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: "1rem",
    justifyContent: "space-between",
  };

  const circleStyle = {
    height: "60px",
    width: "60px",
    borderRadius: "50%",
    backgroundColor: "#fdfdfd",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <>
      <div className="container minht">
        <div className="row">
          <div className="col-md-12 col-lg-4 position-relative ">
            <div className="">
              <div>
                <h2 className="text-capitalize" style={{ fontSize: "50px" }}>
                  {marketTimingData && marketTimingData.title}
                </h2>
                <p className="fs-18">(Highest to Lowest)</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-8">
            <div className="row">
              {marketTimingData &&
                marketTimingData.section.map((card) => (
                  <div key={card._id} className="col-lg-6 ">
                    <div className="card border-1 my-3 mb-md-3 investingBeliefCard" style={{ width: '396px!important', height: '274px' }} onClick={() => handleCardClick(card._id)}>
                      <div className="card-body">
                        <h5 className="card-text investing pb-4 investingBeliefText">{card.title}

                        </h5>
                        <div className="border border-1  circle custom-circle " style={{ position: "absolute", bottom: "25px" }}>
                          <h3 className="text-center lh-53 darktext" > {getCardNumber(card._id)}</h3>
                        </div>
                        <div className="d-flex justify-content-between align-items-center h-50">
                          <div></div>
                          <img
                            src={card.icon}
                            className="card-img-position img-fluid d-block mx-auto"
                            style={{
                              height: "150px",
                              width: "120px",
                            }}
                            alt={card.text}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col text-end">
            <div className="d-flex justify-content-between align-items-center">
              <p className="text-danger fw-semibold">
                {isError}
              </p>
              <div>
                <a onClick={handleBack}>
                  <img
                    className="arrow_next1"
                    src="assets/images/left-arrowpng.png"
                    alt=""
                  />
                </a>
                <a
                  href="javascript:void(0);"
                  className="ms-1"
                  onClick={handleNext}
                >
                  <img
                    className="arrow_next"
                    src="assets/images/right-arrow.svg"
                    alt=""
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MarketTiming;
